import React, { Component } from 'react';

import { connect } from 'react-redux';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';

class OutletInformation extends Component {
  trimCategoryName(category, window_width) {
    if (window_width >= 500) {
      let trimmed_category = category.split(' ');
      if (trimmed_category.length > 1) {
        if (window_width <= 768) {
          let second_word = trimmed_category[1];
          second_word = second_word.toString();
          second_word = `${second_word[0]}${second_word[1]}${second_word[2]} ...`;
          return `${trimmed_category[0]} ${second_word}`;
        } else {
          return category;
        }
      } else {
        return category;
      }
    } else {
      return category;
    }
  }

  getIconClassName(type, activity = false) {
    const root = document.documentElement;
    let primary_color = root.style.getPropertyValue('--highlight-color');
    if (activity === true) primary_color = '#FFFFFF';

    if (type === 'dine_in') {
      return 'icon-dine_in';
    } else if (type === 'delivery') {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.733"
          height="13.975"
          viewBox="0 0 17.733 13.975"
        >
          <g id="ic-ecommerce-delivery" transform="translate(0.5 0.5)">
            <g id="Vrstva_535" data-name="Vrstva 535">
              <path
                id="Path_134"
                data-name="Path 134"
                d="M4.325,15.748H3.667A1.667,1.667,0,0,1,2,14.082V6.157A1.667,1.667,0,0,1,3.667,4.49h8.15a1.667,1.667,0,0,1,1.667,1.667v5.758"
                transform="translate(-2 -4.49)"
                fill="none"
                stroke={`${primary_color}`}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_135"
                data-name="Path 135"
                d="M15.75,8.19h2.317a.983.983,0,0,1,.775.375l1.883,2.5a1.508,1.508,0,0,1,.3.892v4.167a.167.167,0,0,1-.167.167H18.317"
                transform="translate(-4.292 -5.107)"
                fill="none"
                stroke={`${primary_color}`}
                strokeLinecap="round"
                stroke-linejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_29"
                data-name="Ellipse 29"
                cx="1.867"
                cy="1.867"
                r="1.867"
                transform="translate(10.225 9.242)"
                fill="none"
                stroke={`${primary_color}`}
                strokeLinecap="round"
                stroke-linejoin="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_30"
                data-name="Ellipse 30"
                cx="1.867"
                cy="1.867"
                r="1.867"
                transform="translate(2.317 9.242)"
                fill="none"
                stroke={`${primary_color}`}
                strokeLinecap="round"
                stroke-linejoin="round"
                strokeWidth="1"
              />
              <line
                id="Line_121"
                data-name="Line 121"
                x1="4.275"
                transform="translate(5.958 11.217)"
                fill="none"
                stroke={`${primary_color}`}
                strokeLinecap="round"
                stroke-linejoin="round"
                strokeWidth="1"
              />
            </g>
          </g>
        </svg>
      );
    } else if (type === 'curbside_pickup') {
      return 'icon-curbside';
    } else if (type === 'pick_up') {
      return 'icon-pick_up';
    }
  }

  render() {
    const {
      order_time,
      toggleModal,
      classname,
      selected_outlet,
      order_type_id,
      order_type_list
    } = this.props;
    let orderTypeId = this.props.orderTypeId !== null ? this.props.orderTypeId.id : order_type_id;
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : '';
    if (order_type_list) {
      return (
        <React.Fragment>
          <div className={`outlet-information ${classname} card-color hovernowshodow ${card_outline}`} onClick={toggleModal}>
            <div className="outlet-information__outlet outlet-information-mobile">
              <h3 className='card-subtitle-color'>Outlet</h3>
              <h4 className='highlight-color'>{orderTypeId !== null ? `${selected_outlet.toString()}` : '...'}</h4>
            </div>
            <div className="outlet-information__order order-mobile">
              <h3 className='card-subtitle-color'>Order for</h3>
              {OrderTypeHelper.isPickup(order_type_list, orderTypeId) && (
                <>
                  <h4 className='highlight-color'>
                    <span className={`${this.getIconClassName('pick_up', false)}`}></span>
                    {/*<FontAwesomeIcon className='' size={'md'} icon={faShoppingBag} /> */}
                    Takeaway
                  </h4>
                </>
              )}
              {OrderTypeHelper.isDelivery(order_type_list, orderTypeId) && (
                <>
                  <h4 className='highlight-color'>
                    {/*<FontAwesomeIcon className='' size={'md'} icon={faBiking} /> */}
                    {this.getIconClassName('delivery', false)}
                    Delivery
                  </h4>
                </>
              )}
              {OrderTypeHelper.isDineIn(order_type_list, orderTypeId) && (
                <>
                  <h4 className='highlight-color'>
                    {/*<FontAwesomeIcon className='' size={'md'} icon={faUtensils} /> */}
                    <span className={`${this.getIconClassName('dine_in', false)}`}></span>
                    Dine In
                  </h4>
                </>
              )}
              {OrderTypeHelper.isCurbsidePickup(order_type_list, orderTypeId) && (
                <>
                  <h4 className='highlight-color'>
                    {/*<FontAwesomeIcon className='' size={'sm'} icon={faCar} /> */}
                    <span className={`${this.getIconClassName('curbside_pickup', false)}`}></span>
                    Curbside
                  </h4>
                </>
              )}
              {orderTypeId === null || (orderTypeId === '' && <>---</>)}
            </div>
            <div className="outlet-information__serving-time serving-time-mobile ">
              <h3 className='card-subtitle-color'>{this.props._location.custom_delivery_text ? 'Est. delivery time' : 'Serving time'}</h3>
              <h4 className='highlight-color'>{this.props._location.custom_delivery_text ? this.props._location.custom_delivery_text : order_time}</h4>
            </div>
          </div>
        </React.Fragment>
      );
    }
    return '';
  }
}

function mapStateToProps(state) {
  const { prefModalReducer, locationSettings } = state;
  return { orderTypeId: prefModalReducer.orderTypeId, locationSettings };
}

export default connect(mapStateToProps)(OutletInformation);
